/**
 * Helpers for safely deriving border-radius values from theme.shape.borderRadius.
 * Returns a number when the theme value is numeric, or a CSS 'calc(...)' string
 * when the theme value is a unit-bearing string (eg. "8px").
 */
import { Theme } from '@mui/material';

function _getBorderRadius(theme: Theme): number | string | undefined {
  return (theme && theme.shape && (theme.shape as any).borderRadius) as
    | number
    | string
    | undefined;
}

export function radiusHalf(theme: Theme): number | string {
  const br = _getBorderRadius(theme);
  if (typeof br === 'number') return br / 2;
  if (typeof br === 'string') return `calc(${br} / 2)`;
  return 0;
}

export function radiusQuarter(theme: Theme): number | string {
  const br = _getBorderRadius(theme);
  if (typeof br === 'number') return br / 4;
  if (typeof br === 'string') return `calc(${br} / 4)`;
  return 0;
}

export function radiusDouble(theme: Theme): number | string {
  const br = _getBorderRadius(theme);
  if (typeof br === 'number') return br * 2;
  if (typeof br === 'string') return `calc(${br} * 2)`;
  return 0;
}

export function radiusHalfPlus(theme: Theme, offsetPx: number): number | string {
  const br = _getBorderRadius(theme);
  if (typeof br === 'number') return br / 2 + offsetPx;
  if (typeof br === 'string') return `calc(${br} / 2 + ${offsetPx}px)`;
  return offsetPx;
}

export default null;
